import { Box, Stack, Text } from '@chakra-ui/react';

export default function HeroWithTopMedia({ title, subTitle, cta, media }) {
  return (
    <Box maxW={'7xl'} display={'flex'} flexDir={'column'} position={'relative'}>
      <Box
        py={{ base: 5, md: 10 }}
      >
        {media}
      </Box>
      <Stack 
        textAlign={'left'}
        flexGrow={1}
        flexShrink={0}
        flexBasis={'auto'}
        >
          <h3 style={{ fontSize: 'var(--step-1)'}}>{title}</h3>
          <Text           
            position={'relative'}
            whiteSpace={'pre-line'}
            mb={8}
            >
              {subTitle}
          </Text>
          {cta}
        </Stack>
    </Box>
  );
}
